export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const authLogin = userInfo => {
    return { type: AUTH_LOGIN, userInfo: userInfo };
};

export const authLogout = () => {
    return { type: AUTH_LOGOUT };
};